<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">거래 복원</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="lst-option-wrap">
        <div class="lst-option">
          <!-- 바둑판 형 리스트: type은 박스 사이즈 -->
          <!-- page 1 -->
          <div class="lst-option--grid type03">
            <!-- box 1 -->
            <div
              class="box--shd"
              v-for="(hold, index) in holdList.slice(
                (holdCurrentPage - 1) * holdPageCount,
                holdCurrentPage * holdPageCount
              )"
              :key="index"
              @click="restoreOrder(index)"
            >
              <div class="box--hdr space-between">
                <span class="left">{{ index }}</span>
                <span class="right">{{ hold.salesTime }}</span>
              </div>
              <div class="box--body">
                {{ hold.menuArr.length > 0 ? hold.menuArr[0].name : "" }}
              </div>
              <div class="box--ftr">
                {{
                  (hold.totalUprc - hold.totalDiscount - hold.receivedUprc)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
              </div>
            </div>
          </div>
          <!-- // page 1 -->

          <!-- [2023-10-17 구조 변경] 아래 div.swipe-btn-area 요소 추가 -->
          <div class="swipe-btn-area">
            <button
              class="swipe-btn-prev"
              :disabled="holdCurrentPage == 1"
              @click="if (holdCurrentPage != 1) holdCurrentPage--;"
            >
              이전<span class="overlay"></span>
            </button>
            <button
              class="swipe-btn-next"
              :disabled="
                holdCurrentPage == Math.ceil(holdList.length / holdPageCount)
              "
              @click="
                if (
                  holdCurrentPage != Math.ceil(holdList.length / holdPageCount)
                )
                  holdCurrentPage++;
              "
            >
              다음<span class="overlay"></span>
            </button>
          </div>

          <div class="swiper-pagination">
            <span
              class="bullet"
              v-for="(number, index) in Math.ceil(
                holdList.length / holdPageCount
              )"
              :key="index"
              :class="{ on: holdCurrentPage == index + 1 }"
              @click="
                holdCurrentPage = index + 1;
                activeHoldPage = 0;
              "
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "restoreOrder",
  props: {},
  data() {
    return {
      holdList: this.$store.getters.getHoldList,
      holdPageCount: 23,
      holdCurrentPage: 1,
      activeHoldPage: 0,
    };
  },
  methods: {
    restoreOrder(index) {
      this.$.emit("restoreOrder", this.holdList[index]);

      this.holdList.splice(index, 1);
      this.$store.dispatch("setHoldList", this.holdList);

      this.$.emit("close");
    },
    holdChangePage(page) {
      this.holdCurrentPage = page;
    },
  },
  mounted() {},
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


